import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";
import { ComponentProps } from "react";
import { ActivityStatusColors } from "modules/eventActivityStatus/constants";
import { ActivityStatus } from "modules/eventActivityStatus/types";
import ProfileMenu from "./ProfileMenu";

type StyleProps = ComponentProps<typeof ProfileMenu> & {
  status?: ActivityStatus;
};

export const useStyles = makeStyles<Theme, StyleProps>((theme) => ({
  userContainer: {
    height: "100%",

    "&:hover": {
      backgroundColor: "transparent",
      borderColor: "transparent",
    },
  },
  companyContainer: {
    display: "flex",
    height: "60px",
    padding: "10px",
    cursor: "pointer",
    boxSizing: "border-box",

    color: (props) =>
      props.broadcast ? "rgba(255, 255, 255, 0.9)" : theme.palette.text.primary,
    marginRight: (props) => (props.broadcast ? "0px" : "4px"),
    background: (props) => (props.broadcast ? "#1c1f2f" : "transparent"),
    borderRadius: (props) => (props.broadcast ? "0px" : "10px"),
    minWidth: (props) =>
      props.broadcast || props.border ? "190px" : "inherit",
    maxWidth: (props) =>
      props.broadcast || props.border ? "190px" : "inherit",

    "&:hover, &:focus": {
      borderRadius: "10px",
      border: (props) => (props.broadcast ? "none" : "1px solid #cccccc"),
      background: (props) => (props.broadcast ? "#272a39" : "#ffffff"),
    },
  },
  containerContent: {
    padding: 0,
  },
  profileContainer: {
    display: "inline-block",
    width: (props) => (props.contain ? "40px" : "3em"),
    height: (props) => (props.contain ? "40px" : "3em"),
    borderRadius: "50%",
    boxShadow: "none",

    minWidth: "40px",
    maxWidth: (props) => (props.contain ? "inherit" : "40px"),
    minHeight: (props) => (props.contain ? "40px" : "inherit"),
    maxHeight: (props) => (props.contain ? "inherit" : "40px"),
  },
  companyInfo: {
    width: "100%",
    display: "flex",
    textAlign: "left",
    padding: "4px 0px 8px 16px",
    justifyContent: "space-between",
    alignItems: "center",
  },
  companyName: {
    maxWidth: "85px",
    fontSize: "14px",
    lineHeight: "16px",
    fontWeight: 500,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  companyRole: {
    fontSize: "12px",
    lineHeight: "14px",
  },
  arrowIcon: {
    color: theme.palette.present.greyBackground,
  },
  activityBadge: ({ status }) => ({
    height: "16px",
    minWidth: "16px",
    borderRadius: "999px",
    border: status ? "1px solid white" : "none",
    backgroundColor: status ? ActivityStatusColors[status] : "rgba(0,0,0,0)",
  }),
}));
